module.exports = __webpack_public_path__ + "static/img/Gtu3@2x.0687b012.png";